<template>
  <div class="mainContainer">
    <div class="nav">
      <div class="navContainer" style="width: 250px">
        <p>对账单编号：</p>
        <el-input v-model="numIpt" size="mini" style="width:150px" placeholder="请输入对账单编号"/>
      </div>
      <div class="navContainer">
        <p>标题：</p>
        <el-input v-model="titleIpt" size="mini" style="width:150px" placeholder="请输入标题"/>
      </div>
      <div class="navContainer" style="width: 210px">
        <p>委托商：</p>
        <el-input v-model="entrustIpt" size="mini" style="width:150px" placeholder="请输入委托商"/>
      </div>
      <div class="navContainer" style="width: 420px">
        <p style="width: 120px">对账单生成时间：</p>
        <el-date-picker v-model="timeIpt[0]" size="mini" style="width:150px" value-format="yyyy-MM-dd HH:mm:ss" @change="dateChange" type="datetime" placeholder="开始日期"/>
        <span style="display:inline-block;width:15px;text-align:center;font-size:18px">-</span>
        <el-date-picker v-model="timeIpt[1]" size="mini" style="width:150px" value-format="yyyy-MM-dd HH:mm:ss" @change="dateChange" type="datetime" placeholder="结束日期"/>
      </div>
      <div class="navContainer" style="width: 230px">
        <p>结算方式：</p>
        <el-select v-model="typeIpt" filterable size="mini" style="width:150px" placeholder="请选择发票方式">
          <el-option v-for="item in typeOption" :key="item.label" :label="item.label" :value="item.value"/>
        </el-select>
      </div>
      <div class="navContainer">
        <p>状态：</p>
        <el-select v-model="stateIpt" filterable size="mini" style="width:150px" placeholder="请选择状态">
          <el-option v-for="item in stateOption" :key="item.label" :label="item.label" :value="item.value"/>
        </el-select>
      </div>
      <div class="navBtn">
        <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
        <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
      </div>
    </div>
    <div class="content">
      <div class="tableContainer">
        <el-table
          v-loading="tableLoad"
          :data="TableDatas"
          style="width: 100%"
          border
          stripe
          :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
          :expand-row-keys="expands"
          :row-key="bindRowKeys"
        >
          <el-table-column type="expand" width="1">
            <template slot-scope="scopeOut">
              <div style="width: 50%;margin-left: auto;">
                <el-table
                  v-show="scopeOut.row.tableShow"
                  :data="scopeOut.row.child"
                  border
                  stripe
                  style="width: 100%"
                  :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
                  :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
                >
                  <el-table-column label="序号" align="center" type="index"/>
                  <el-table-column label="对账单生成时间" align="center"/>
                  <el-table-column prop="entrust" label="预结算含税价" align="center"/>
                  <el-table-column prop="dealers" label="预结算不含税价" align="center"/>
                  <el-table-column prop="planDate" label="状态" align="center"/>
                  <el-table-column label="操作" align="center" width="350">
                    <template slot-scope="innerScope">
                      <div style="display:flex;align-items:center;padding-left: 10px">
                        <el-button v-if="!innerScope.row.state" size="mini" class="searchBtn" type="primary" @click="changeClick(innerScope.row.id)">核对对账单</el-button>
                        <el-button size="mini" class="searchBtn" type="primary" @click="detailClick(innerScope.row.id)">详情</el-button>
                        <el-button v-if="innerScope.row.state" size="mini" type="primary" @click="auditClick(innerScope.row.id)">提交审核</el-button>
                        <el-button v-if="!innerScope.row.state" size="mini" type="primary" @click="invoiceClick(innerScope.row.id)">已收发票</el-button>
                        <el-button v-if="scope.row.status===3" size="mini" class="yellow-bg" type="primary" @click="collectionClick(scope.row.id)">催收开票</el-button>
                        <el-button v-if="!innerScope.row.state" size="mini" type="info" @click="deleteClick(innerScope.row.id)">删除</el-button>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="序号" align="center" width="50px" type="index"/>
          <el-table-column prop="consignorName" label="对账单编号" align="center"/>
          <el-table-column prop="customerCarName" label="标题" align="center"/>
          <el-table-column label="委托商" align="center">
            <div slot-scope="scope" style="display:flex;align-items:center;justify-content:center">
              {{scope.row.entrust}}<el-tooltip :content="`原结算单位：${scope.row.tip}`" placement="bottom" effect="light"><img v-if="scope.row.tip" alt="" :src="require('@/assets/images/warnning.png')"/></el-tooltip>
            </div>
          </el-table-column>
          <el-table-column prop="shipmentAddrName" label="对账单生成时间" align="center"/>
          <el-table-column prop="shipmentAddrName" label="结算方式" align="center"/>
          <el-table-column prop="startDate" label="合计含税费用" align="center"/>
          <el-table-column prop="endDate" label="合计不含税费用" align="center"/>
          <el-table-column prop="endDate" label="已开票" align="center"/>
          <el-table-column prop="status" label="状态" align="center">
            <div slot-scope="scope">{{getState(scope.row.status)}}</div>
          </el-table-column>
          <el-table-column label="操作" width="345" align="center">
            <template slot-scope="scope">
              <div style="display:flex;align-items:center;padding-left: 10px">
                <el-button v-if="!scope.row.status" size="mini" class="searchBtn" type="primary" @click="changeClick(scope.row.id)">核对对账单</el-button>
                <el-button size="mini" class="searchBtn" type="primary" @click="detailClick(scope.row.id)">详情</el-button>
                <el-button v-if="!scope.row.status" size="mini" type="primary" @click="auditClick(scope.row.id)">提交审核</el-button>
                <el-button v-if="scope.row.status===1" size="mini" type="danger" @click="disableClick(scope.row.id)">取消审核</el-button>
                <el-button v-if="scope.row.child.length!==0" size="mini" class="resetBtn" type="primary" @click="hiddenClick(scope.$index, scope.row)">
                  <div style="cursor:pointer;">
                    <span>{{scope.row.tableShow?'隐藏':'展开'}}</span>
                    <i
                      v-if="scope.row.child.length!==0"
                      class="el-icon el-icon-arrow-right"
                      style="margin-right: 5px;transition: all .3s"
                      :style="scope.row.tableShow?'transform:rotate(90deg);':''"
                    />
                  </div>
                </el-button>
                <el-button v-if="scope.row.status===1" size="mini" class="yellow-bg" type="primary">添加对账单</el-button>
                <el-button v-if="scope.row.status===3" size="mini" type="primary" @click="invoiceClick(scope.row.id)">已收发票</el-button>
                <el-button v-if="scope.row.status===3" size="mini" class="yellow-bg" type="primary" @click="collectionClick(scope.row.id)">催收开票</el-button>
                <el-button v-if="!scope.row.status" size="mini" type="info" @click="deleteClick(scope.row.id)">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <span>共{{total}}条</span>
        <el-pagination
          background
          :page-sizes="[10, 20, 30, 40]"
          layout="sizes,prev, pager, next,jumper"
          :total="total"
          @size-change="contractSizeChange"
          @current-change="contractCurrentChange"
          @prev-click="contractCurrentChange"
          @next-click="contractCurrentChange"
        />
      </div>
    </div>
    <el-dialog title="详情" :visible.sync="detailDialogVisible" :width='detailDialogWidth' @close="detailClose" center top="10vh">
      <div class="detail">
        <el-tabs v-model="activeName">
          <el-tab-pane label="基础信息" name="first">
            <div class="baseInfo">
              <div class="baseInfoContent">
                <div class="baseInfoContentItem">
                  <span class="span1">对账单编号：</span>
                  <span>{{detailData.name}}</span>
                </div>
                <div class="baseInfoContentItem">
                  <span class="span1">标题：</span>
                  <span>{{detailData.name}}</span>
                </div>
                <div class="baseInfoContentItem">
                  <span class="span1">委托商：</span>
                  <span>{{detailData.time1}}</span>
                </div>
                <div class="baseInfoContentItem">
                  <span class="span1">结算方式：</span>
                  <span>{{detailData.time2}}</span>
                </div>
                <div class="baseInfoContentItem specialItem">
                  <div class="specialOne">
                    <span class="span1">合计含税费用：</span>
                    <span>{{detailData.customerNatureName}}</span>
                  </div>
                  <div>
                    <span class="span1">合计不含税费用：</span>
                    <span>{{detailData.customerScaleName}}</span>
                  </div>
                </div>
                <div class="baseInfoContentItem specialItem">
                  <div class="specialOne">
                    <span class="span1">实际含税费用：</span>
                    <span>{{detailData.customerNatureName}}</span>
                    <el-tooltip placement="bottom" effect="light">
                      <div slot="content">
                        <span style="color: #999;">基础托运费用{{detailData.price}}元</span><br/>
                        <span style="color: #999;">基础其它费用{{detailData.price}}元</span><br/>
                        <span style="color: #FF3A30">抵扣超出合同价对账单{{detailData.price}}元</span><br/>
                        <span style="color: #FF3A30">暂缓开票{{detailData.price}}元</span><br/>
                      </div>
                      <i class="el-icon-warning" style="color: red;font-size: 18px;margin-right: 5px;"/>
                    </el-tooltip>
                  </div>
                  <div>
                    <span class="span1">实际不含税费用：</span>
                    <span>{{detailData.customerScaleName}}</span>
                  </div>
                </div>
                <div class="baseInfoContentItem">
                  <span class="span1">生成对账单时间：</span>
                  <span>{{detailData.time2}}</span>
                </div>
              </div>
            </div>
            <div class="operation">
              <div class="operationTitle">
                <div class="line"/>
                <span>抵扣对账单</span>
              </div>
              <div class="operationTable">
                <el-table :data="detailData.table1" border>
                  <el-table-column label="序号" align="center" type="index"/>
                  <el-table-column prop="operateType" label="对账单编号" align="center"/>
                  <el-table-column prop="operationName" label="抵扣费用" align="center"/>
                </el-table>
              </div>
            </div>
            <div class="baseInfo">
              <div class="baseInfoTitle">
                <div class="line"/>
                <span>审核信息</span>
              </div>
              <div style="width:70%">
                <steps :step-data="stepData" :step-state="stepState"/>
              </div>
            </div>
            <div class="operation">
              <div class="operationTitle">
                <div class="line"/>
                <span>操作记录</span>
              </div>
              <div class="operationTable">
                <el-table :data="operationData" border>
                  <el-table-column label="操作时间" align="center" width="160px">
                    <div slot-scope="scope">{{getTime(scope.row.createTime)}}</div>
                  </el-table-column>
                  <el-table-column prop="operateType" label="操作类型" align="center"/>
                  <el-table-column prop="operationName" label="操作人" align="center"/>
                  <el-table-column prop="remark" label="备注" align="center"/>
                </el-table>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="托运费用" name="second">
            <div class="baseInfo">
              <div class="baseInfoContent" style="padding: 0">
                <div class="baseInfoContentItem specialItem">
                  <div class="specialOne">
                    <span class="span1">合计含税结算金额：</span>
                    <span>{{detailData.customerNatureName}}</span>
                  </div>
                  <div>
                    <span class="span1">合计不含税结算金额：</span>
                    <span>{{detailData.customerScaleName}}</span>
                  </div>
                </div>
              </div>
              <div class="operationTable" style="margin-top:0">
                <div class="operationTableNav">
                  <span>导出数据</span>
                </div>
                <el-table
                  :data="detailTable"
                  border
                  script
                >
                  <el-table-column prop="waybill" label="运单编号" align="center"/>
                  <el-table-column prop="type" label="批次号" align="center"/>
                  <el-table-column prop="remark2" label="底盘号" align="center"/>
                  <el-table-column prop="batch" label="品牌" align="center"/>
                  <el-table-column prop="rate" label="型号" align="center"/>
                  <el-table-column prop="price" label="委托商" align="center"/>
                  <el-table-column prop="price2" label="经销商" align="center"/>
                  <el-table-column prop="remark" label="计划日期" align="center"/>
                  <el-table-column prop="remark" label="发运日期" align="center"/>
                  <el-table-column prop="remark" label="运输条款" align="center"/>
                  <el-table-column prop="remark" label="税率(%)" align="center"/>
                  <el-table-column prop="remark" label="含税合同价" align="center"/>
                  <el-table-column prop="remark" label="不含税合同价" align="center"/>
                  <el-table-column prop="remark" label="预结算方式" align="center"/>
                  <el-table-column prop="remark" label="含税预结算价" align="center"/>
                  <el-table-column prop="remark" label="不含税预结算价" align="center"/>
                </el-table>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="其它费用" name="third">
            <div class="baseInfo">
              <div class="baseInfoContent" style="padding: 0">
                <div class="baseInfoContentItem specialItem">
                  <div class="specialOne">
                    <span class="span1">合计含税结算金额：</span>
                    <span>{{detailData.customerNatureName}}</span>
                  </div>
                  <div>
                    <span class="span1">合计不含税结算金额：</span>
                    <span>{{detailData.customerScaleName}}</span>
                  </div>
                </div>
              </div>
              <div class="operationTable" style="margin-top:0">
                <el-table
                  :data="detailTable3"
                  border
                  script
                >
                  <el-table-column label="序号" align="center" type="index"/>
                  <el-table-column prop="type" label="费用编号" align="center"/>
                  <el-table-column prop="remark2" label="费用类型" align="center"/>
                  <el-table-column prop="batch" label="费用说明" align="center"/>
                  <el-table-column prop="price" label="费用时间" align="center"/>
                  <el-table-column prop="remark" label="税率(%)" align="center"/>
                  <el-table-column prop="remark" label="含税价" align="center"/>
                  <el-table-column prop="remark" label="不含税价" align="center"/>
                  <el-table-column prop="remark" label="说明" align="center"/>
                </el-table>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="开票信息" name="fourth">
            <div class="baseInfo">
              <div class="baseInfoContent" style="padding: 0">
                <div class="baseInfoContentItem">
                  <span class="span1">是否抵扣开票：</span>
                  <span>{{detailData.time2}}</span>
                </div>
                <div class="baseInfoContentItem">
                  <span class="span1">抵扣开票费用编号：</span>
                  <span>{{detailData.time2}}</span>
                </div>
                <div class="baseInfoContentItem">
                  <span class="span1">确认收到发票时间：</span>
                  <span>{{detailData.time2}}</span>
                </div>
                <div class="baseInfoContentItem">
                  <div class="imgContainer">
                    <el-image
                      v-for="(item,index) in detailData.img"
                      :key="index"
                      style="width: 100px; height: 100px;margin-right:10px; "
                      :src="baseImgUrl + item"
                      :preview-src-list="[baseImgUrl + item]"
                      fit="cover"
                    />
                  </div>
                </div>
                <div class="baseInfoContentItem specialItem">
                  <div class="specialOne">
                    <span class="span1">原开票金额：</span>
                    <span>{{detailData.customerNatureName}}</span>
                  </div>
                  <div>
                    <span class="span1">抵扣金额：</span>
                    <span>{{detailData.customerScaleName}}</span>
                  </div>
                  <div>
                    <span class="span1">实际开票金额：</span>
                    <span>{{detailData.customerScaleName}}</span>
                  </div>
                </div>
              </div>
              <div class="operationTable" style="margin-top:0">
                <el-table
                  :data="detailTable2"
                  border
                  script
                >
                  <el-table-column label="序号" align="center" type="index"/>
                  <el-table-column prop="type" label="发票号码" align="center"/>
                  <el-table-column prop="remark2" label="发票金额" align="center"/>
                  <el-table-column prop="batch" label="发票日期" align="center"/>
                  <el-table-column prop="rate" label="发票类型" align="center"/>
                  <el-table-column prop="price" label="发票税率" align="center"/>
                  <el-table-column prop="price2" label="核销期限" align="center"/>
                  <el-table-column prop="remark" label="创建日期" align="center"/>
                </el-table>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-dialog>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width='1200px' center @close="dialogClose" :close-on-click-modal="false">
      <div class="detail">
        <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line"/>
            <span>基础信息</span>
          </div>
          <div class="baseInfoContent">
            <div class="baseInfoContentItem">
              <span class="span1">委托商：</span>
              <span>{{companyData.name}}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">标题：</span>
              <span>{{companyData.title}}</span>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">合计含税费用：</span>
                <span>{{companyData.customerNatureName}}</span>
              </div>
              <div>
                <span class="span1">合计不含税费用：</span>
                <span>{{companyData.customerScaleName}}</span>
              </div>
            </div>
            <el-tabs v-model="activeName">
              <el-tab-pane label="托运费用核对" name="first">
                <div class="baseInfoContentItem">
                  <span class="span1">结算方式：</span>
                  <span>{{companyData.name}}</span>
                </div>
                <div class="baseInfoContentItem specialItem">
                  <div class="specialOne">
                    <span class="span1">托运费合计含税费用：</span>
                    <span>{{companyData.customerNatureName}}</span>
                  </div>
                  <div>
                    <span class="span1">托运费合计不含税费用：</span>
                    <span>{{companyData.customerScaleName}}</span>
                  </div>
                </div>
                <div class="baseInfoContentItem">
                  <span class="span1">上传时间：</span>
                  <span>{{companyData.time}}</span>
                  <span style="text-decoration: underline;color: rgb(51, 136, 255);cursor: pointer;margin-left: 10px;">下载</span>
                  <span style="text-decoration: underline;color: rgb(51, 136, 255);cursor: pointer;margin-left: 10px;">重新上传</span>
                </div>
              </el-tab-pane>
              <el-tab-pane label="其它费用核对" name="second">
                <div class="baseInfoContentItem specialItem">
                  <div class="specialOne">
                    <span class="span1">其它费合计含税费用：</span>
                    <span>{{companyData.customerNatureName}}</span>
                  </div>
                  <div>
                    <span class="span1">其它费合计不含税费用：</span>
                    <span>{{companyData.customerScaleName}}</span>
                  </div>
                </div>
                <div class="baseInfoContentItem">
                  <span class="span1">上传时间：</span>
                  <span>{{companyData.time}}</span>
                  <span style="text-decoration: underline;color: rgb(51, 136, 255);cursor: pointer;margin-left: 10px;">下载</span>
                  <span style="text-decoration: underline;color: rgb(51, 136, 255);cursor: pointer;margin-left: 10px;">重新上传</span>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
          <div class="operation">
            <div class="operationTitle">
              <div class="line"/>
              <span>{{activeName==='first'?'已选择运单':'已选择其它费用'}}</span>
            </div>
            <div class="operationTable" v-if="activeName==='first'">
              <el-table
                :data="tableData1"
                :row-class-name="tableRowClassName"
                border
                script
              >
                <el-table-column label="序号" align="center" type="index"/>
                <el-table-column prop="waybill" label="运单编号" align="center"/>
                <el-table-column prop="batch" label="批次号" align="center"/>
                <el-table-column prop="chassis" label="底盘号" align="center"/>
                <el-table-column prop="brand" label="品牌" align="center"/>
                <el-table-column prop="model" label="型号" align="center"/>
                <el-table-column prop="date1" label="计划日期" align="center"/>
                <el-table-column prop="date2" label="发运日期" align="center"/>
                <el-table-column prop="date3" label="交车日期" align="center"/>
                <el-table-column prop="start" label="起始地" align="center"/>
                <el-table-column prop="end" label="交车地" align="center"/>
                <el-table-column prop="type" label="费用类型" align="center"/>
                <el-table-column prop="rate" label="税率(%)" align="center"/>
                <el-table-column prop="price1" label="含税合同价" align="center"/>
                <el-table-column prop="price2" label="不含税合同价" align="center"/>
                <el-table-column prop="remark" label="说明" align="center"/>
                <el-table-column label="操作" align="center" width="170">
                  <template slot-scope="scope">
                    <div style="display:flex;align-items:center;padding-left: 10px">
                      <el-button size="mini" type="primary" @click="changePriceClick(scope.$index, scope.row)">修改金额</el-button>
                      <el-button size="mini" type="danger" @click="removeClick(scope.$index, 0)">删除</el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="operationTable" v-else>
              <div class="operationTableNav">
                <span @click="exportClick">添加</span>
              </div>
              <el-table
                :data="tableData2"
                :row-class-name="tableRowClassName"
                border
                script
              >
                <el-table-column label="序号" align="center" type="index"/>
                <el-table-column prop="waybill" label="费用编号" align="center"/>
                <el-table-column prop="type" label="费用类型" align="center"/>
                <el-table-column prop="remark2" label="费用说明" align="center"/>
                <el-table-column prop="batch" label="费用时间" align="center"/>
                <el-table-column prop="rate" label="税率(%)" align="center"/>
                <el-table-column prop="price1" label="含税价" align="center"/>
                <el-table-column prop="price2" label="不含税价" align="center"/>
                <el-table-column prop="remark" label="说明" align="center"/>
                <el-table-column label="操作" align="center" width="50px">
                  <div slot-scope="scope" style="display:flex;align-items:center;justify-content:center" v-if="tableData2.length>1">
                    <img alt="" :src="require('@/assets/images/u725.png')" :style="'width:22px;height:22px;cursor: pointer;'" @click="removeClick(scope.$index,1)"/>
                  </div>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div class="operation">
            <div class="operationTitle">
              <div class="line"/>
              <span>{{activeName==='first'?'未选择运单':'未选择其它费用'}}</span>
            </div>
            <div class="operationTable" v-if="activeName==='first'">
              <el-table
                :data="tableData3"
                :row-class-name="tableRowClassName"
                border
                script
              >
                <el-table-column label="序号" align="center" type="index"/>
                <el-table-column prop="waybill" label="运单编号" align="center"/>
                <el-table-column prop="batch" label="批次号" align="center"/>
                <el-table-column prop="chassis" label="底盘号" align="center"/>
                <el-table-column prop="brand" label="品牌" align="center"/>
                <el-table-column prop="model" label="型号" align="center"/>
                <el-table-column prop="type" label="费用类型" align="center"/>
                <el-table-column prop="rate" label="税率(%)" align="center"/>
                <el-table-column prop="price1" label="含税合同价" align="center"/>
                <el-table-column prop="price2" label="不含税合同价" align="center"/>
                <el-table-column prop="remark" label="说明" align="center"/>
                <el-table-column label="操作" align="center" width="170">
                  <template slot-scope="scope">
                    <div style="display:flex;align-items:center;padding-left: 10px">
                      <el-button size="mini" type="primary" @click="addTableClick(scope.$index, 0)">添加</el-button>
                      <el-button size="mini" type="primary">首页提醒</el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="operationTable" v-else>
              <el-table
                :data="tableData4"
                :row-class-name="tableRowClassName"
                border
                script
              >
                <el-table-column label="序号" align="center" type="index"/>
                <el-table-column prop="waybill" label="运单编号" align="center"/>
                <el-table-column prop="batch" label="批次号" align="center"/>
                <el-table-column prop="chassis" label="底盘号" align="center"/>
                <el-table-column prop="brand" label="品牌" align="center"/>
                <el-table-column prop="model" label="型号" align="center"/>
                <el-table-column prop="type" label="费用类型" align="center"/>
                <el-table-column prop="rate" label="税率(%)" align="center"/>
                <el-table-column prop="price1" label="含税合同价" align="center"/>
                <el-table-column prop="price2" label="不含税合同价" align="center"/>
                <el-table-column prop="remark" label="说明" align="center"/>
                <el-table-column label="操作" align="center" width="75">
                  <template slot-scope="scope">
                    <div style="display:flex;align-items:center;padding-left: 10px">
                      <el-button size="mini" type="primary" @click="addTableClick(scope.$index, 1)">添加</el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="选择适配车型" :visible.sync="carVisible" width='600px' @close="carClose" center :close-on-click-modal="false" top="20vh">
      <div class="carContainer">
        <div class="carContainerTitle">
          <span>已选择车型：</span>
          <div class="carContainerTitleContent">
            <div class="carContainerTitleContentItem" v-for="item in selectCar" @click="selectRemove(item)">
              {{item.name}}<i class="el-icon-close"/>
            </div>
          </div>
        </div>
        <div class="carContainerTitle">
          <span>选择品牌：</span>
          <div class="carContainerTitleContent">
            <div class="carContainerTitleContentItem" v-for="item in selectBrand">
              <p @click="brandClick(item.id)">{{item.name}}&nbsp;</p><i class="el-icon-plus" @click="brandAdd(item)"/>
            </div>
          </div>
        </div>
        <div class="carContainerTitle">
          <span>选择型号：</span>
          <div class="carContainerTitleContent">
            <div class="carContainerTitleContentItem" v-for="item in selectModel" @click="modelAdd(item)">
              <p>{{item.name}}</p><i class="el-icon-plus"/>
            </div>
          </div>
        </div>
        <div class="btnContainer">
          <el-button class="mini" size="medium" @click="carAddClick">确定</el-button>
          <el-button class="mini" size="medium" @click="carClose">关闭</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="添加其它费用" :visible.sync="addVisible" width='1000px' @close="addClose" center :close-on-click-modal="false" top="20vh">
      <div class="addCost">
        <div class="addCostNav">
          <div class="navContainer" style="width: 230px">
            <p>费用编号：</p>
            <el-input v-model="cost.num" size="mini" style="width:150px" placeholder="请输入费用编号"/>
          </div>
          <div class="navContainer" style="width: 230px">
            <p>费用类型：</p>
            <el-input v-model="cost.type" size="mini" style="width:150px" placeholder="请输入费用类型"/>
          </div>
          <div class="navContainer" style="width: 470px">
            <p>费用时间：</p>
            <el-date-picker
              v-model="cost.time"
              type="datetimerange"
              size="mini"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="至"
              start-placeholder="开始费用时间"
              end-placeholder="结束费用时间"/>
          </div>
          <div class="navBtn">
            <el-button size="small" class="searchBtn" @click="costSearch">查询</el-button>
            <el-button size="small" class="resetBtn" @click="resetBtn2">重置</el-button>
          </div>
        </div>
        <div class="addCostTable">
          <el-table
            :data="costTable"
            border
            script
            @select="handleSelectionChange"
            @select-all="selectAll"
            :row-key="bindRowKeys"
          >
            <el-table-column width="50" :reserve-selection="true" type="selection"/>
            <el-table-column prop="waybill" label="费用编号" align="center"/>
            <el-table-column prop="type" label="费用类型" align="center"/>
            <el-table-column prop="remark2" label="费用说明" align="center"/>
            <el-table-column prop="batch" label="费用时间" align="center"/>
            <el-table-column prop="rate" label="税率(%)" align="center"/>
            <el-table-column prop="price1" label="含税价" align="center"/>
            <el-table-column prop="price2" label="不含税价" align="center"/>
          </el-table>
        </div>
        <div class="paginationContainer">
          <span>共{{costTotal}}条</span>
          <el-pagination
            background
            :page-sizes="[10, 20, 30, 40]"
            layout="sizes,prev, pager, next,jumper"
            :total="costTotal"
            @size-change="contractSizeChange1"
            @current-change="contractCurrentChange1"
            @prev-click="contractCurrentChange1"
            @next-click="contractCurrentChange1"
          />
        </div>
      </div>
    </el-dialog>
    <el-dialog title="已收发票" :visible.sync="invoiceVisible" width='600px' @close="invoiceClose" center :close-on-click-modal="false">
      <div class="depart">
        <el-form :model="invoiceData" label-width="110px" :rules="rules" ref="ruleForm" size="medium">
          <div-border label="开票选择" divStyle="margin-top: 10px">
            <el-form-item label="收取时间：" prop="date" style="margin-top: 10px;">
              <el-date-picker
                v-model="invoiceData.date"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                size="mini"
                placeholder="请选择收取时间"/>
            </el-form-item>
            <el-form-item label="备注：">
              <el-input
                :style="'width:100%'"
                type="textarea"
                v-model="invoiceData.remark"
                placeholder="请输入备注"
                autocomplete="off"
                size="mini"
              />
            </el-form-item>
          </div-border>
          <div-border label="上传凭证" divStyle="margin-top: 10px;padding-bottom:10px;">
            <div class="imgUp">
              <div class="imgLength"><span>{{invoiceData.img.length}}/5</span></div>
              <el-upload
                ref="uploads"
                list-type="picture-card"
                :action="uploadUrl"
                :data="uploadData"
                :before-upload="beforeAvatarUpload"
                :on-change="uploadChange"
                :on-remove="handleRemove"
                :on-progress="progress"
                :on-success="success"
                accept="image/png, image/jpeg, image/jpeg, image/bmp, image/gif"
                :file-list="invoiceData.img"
                :limit="5"
              >
                <div class="img-box">
                  <i class="el-icon-plus"/>
                  <span class="tips">点击上传照片</span>
                </div>
              </el-upload>
            </div>
          </div-border>
          <div class="btnContainer">
            <el-button size="medium" class="searchBtn" :loading="imgIsUpload" @click="addClick">确定</el-button>
            <el-button size="medium" class="resetBtn" @click="invoiceClose">关闭</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog title="提交审核" :visible.sync="auditVisible" width='600px' @close="auditClose" center :close-on-click-modal="false">
      <div class="depart">
        <el-form :model="auditData" label-width="120px" :rules="rules2" ref="ruleForm2" size="medium">
          <div-border label="超出合同价" divStyle="margin-top: 10px;padding-top:15px;">
            <span style="color: #FF3A30;margin-left: 10px;">发现当前委托商有往期超出合同价未结算完！</span>
            <el-form-item label="是否抵扣超出合同价：" prop="deduction" label-width="160px">
              <el-radio v-model="auditData.deduction" :label="1">否</el-radio>
              <el-radio v-model="auditData.deduction" :label="0">是</el-radio>
            </el-form-item>
            <el-form-item v-if="auditData.deduction===0" label="最多可抵扣费用：" style="margin-bottom: 0">
              {{auditData.maxPrice}}元
            </el-form-item>
            <div class="departTable" v-if="auditData.deduction===0">
              <el-table border :data="auditData.table">
                <el-table-column label="序号" align="center" type="index"/>
                <el-table-column label="对账单编号" align="center">
                  <template slot-scope="scope">
                    <el-select v-model="auditData.table[scope.$index].num" filterable size="mini" style="width:100%" placeholder="请选择对账单" @change="numChange(scope.$index)">
                      <el-option v-for="item in numOption" :key="item.value" :label="item.label" :value="item.value"/>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column label="最大抵扣费用" align="center" prop="max"/>
                <el-table-column label="抵扣费用" align="center" prop="price">
                  <template slot-scope="scope">
                    <el-input v-model="auditData.table[scope.$index].price" size="mini" style="width:100%" placeholder="请输入抵扣费用"/>
                  </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                  <div slot-scope="scope" style="display:flex;align-items:center;justify-content:center">
                    <img v-if="auditData.table.length!==1" alt="" :src="require('@/assets/images/u725.png')" :style="'width:22px;height:22px;cursor: pointer;'" @click="numRemoveClick(scope.$index)"/>
                  </div>
                </el-table-column>
              </el-table>
              <div class="tableAddBtnContainer">
                <div class="AddContainer" @click="addCl">
                  <img alt="" :src="require('@/assets/images/u131.png')" />
                  <p>新增</p>
                </div>
              </div>
            </div>
          </div-border>
          <div-border label="开票选择" divStyle="margin-top: 10px;padding-top:15px;">
            <el-form-item label="开票总金额：" style="margin-bottom: 0">
              {{auditData.total}}元
            </el-form-item>
            <div style="display: flex;align-items: center;height: 50px;">
              <el-form-item label="是否暂缓开票：" style="margin-bottom: 5px;" prop="invoice">
                <el-radio v-model="auditData.invoice" :label="1">否</el-radio>
                <el-radio v-model="auditData.invoice" :label="0">是</el-radio>
              </el-form-item>
              <el-form-item v-if="!auditData.invoice" prop="invoicePrice" class="specialItem" style="margin-left: 10px;">
                <el-input type="number" v-if="!auditData.invoice" v-model="auditData.invoicePrice" size="mini" style="width:100%" placeholder="请输入暂缓开票金额">
                  <span slot="suffix" style="color: #999">|  元</span>
                </el-input>
              </el-form-item>
            </div>
            <el-form-item label="开票方式：" prop="type">
              <el-radio v-model="auditData.type" :label="1">自动</el-radio>
              <el-radio v-model="auditData.type" :label="0">手动</el-radio>
            </el-form-item>
            <el-form-item label="预计开票数量：" style="margin-bottom: 18px;">
              {{auditData.table2.length}}
            </el-form-item>
            <div class="departTable" style="padding-left: 20%">
              <el-table border :data="auditData.table2">
                <el-table-column label="序号" align="center" type="index"/>
                <el-table-column label="开票金额" align="center" prop="price">
                  <template slot-scope="scope">
                    <el-input :disabled="auditData.type===1" v-model="auditData.table2[scope.$index].price" size="mini" style="width:100%" placeholder="请输入开票金额"/>
                  </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                  <div slot-scope="scope" style="display:flex;align-items:center;justify-content:center">
                    <img v-if="auditData.table2.length!==1 && auditData.type===0" alt="" :src="require('@/assets/images/u725.png')" :style="'width:22px;height:22px;cursor: pointer;'" @click="invoiceRemoveClick(scope.$index)"/>
                  </div>
                </el-table-column>
              </el-table>
              <div class="tableAddBtnContainer" v-if="auditData.type!==1">
                <div class="AddContainer" @click="addCl2">
                  <img alt="" :src="require('@/assets/images/u131.png')" />
                  <p>新增</p>
                </div>
              </div>
            </div>
          </div-border>
          <div class="btnContainer">
            <el-button size="medium" class="searchBtn" @click="auditConfirmClick">确定</el-button>
            <el-button size="medium" class="resetBtn" @click="auditClose">关闭</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import steps from "@/components/steps";
import {formatDateTime} from "@/config/mUtils";
import divBorder from "@/components/divBorder";
import {baseImgUrl} from "@/config/env";

export default {
  components: {
    steps,
    divBorder,
  },
  data() {
    return {
      activeName:'first',
      entrustIpt:'',
      titleIpt:'',
      numIpt:'',
      typeIpt:'',
      stateIpt:'',
      timeIpt:['',''],
      stateOption:[
        {value:'',label:'全部',},
        {value:0,label:'待生效'},
        {value:1,label:'生效中'},
        {value:2,label:'已失效'},
      ],
      typeOption:[],
      page:1,
      size:10,
      total:0,
      tableLoad:false,
      TableDatas:[
        // {id:111,show:false,entrust:'委托商1',tip:'重庆市xxxx',status:1,tableShow:false,child:[
        //     {id:222,state:1},
        //     {id:333,state:0},
        //   ]},
        // {id:444,show:false,entrust:'委托商1',status:0,tableShow:false,child:[]},
        // {id:555,show:true,entrust:'委托商1',status:2,tableShow:false,child:[]},
        // {id:666,show:true,entrust:'委托商1',status:3,tableShow:false,child:[]},
      ],
      detailDialogVisible:false,
      detailDialogWidth:'700px',
      detailTable:[
        {price: 12,}
      ],
      detailTable2:[
        {price: 12,}
      ],
      detailTable3:[
        {price: 12,}
      ],
      detailData:{
        table1:[],
        img:[],
      },
      baseImgUrl: baseImgUrl+ '/',
      operationData:[],
      dialogVisible:false,
      dialogTitle:'',
      nameOption:[],
      payOption:[],
      addressOption:[],
      uploadData: {
        fileType: '1',
      },
      tableData1:[
        {waybill:'BH2011541',batch:'PC2011541',chassis:'DP2011541',brand:'品牌1',model:'型号',date1:'2021-10-30',date2:'2021-10-30',date3:'2021-10-30',start:'委托商1',end:'经销商1',type:'托运',rate:'1',price1:'60',price2:'60',remark:'相等'},
        {waybill:'BH2011541',batch:'PC2011541',chassis:'DP2011541',brand:'品牌1',model:'型号',date1:'2021-10-30',date2:'2021-10-30',date3:'2021-10-30',start:'委托商1',end:'经销商1',type:'质损',rate:'2',price1:'50',price2:'60',remark:'价格异常'},
        {waybill:'BH2011541',batch:'PC2011541',chassis:'DP2011541',brand:'品牌1',model:'型号',date1:'2021-10-30',date2:'2021-10-30',date3:'2021-10-30',start:'委托商1',end:'经销商1',type:'塔电',rate:'2',price1:'60',price2:'60',remark:'相等'},
      ],
      tableData2:[
        {waybill:'BH2011541',type:'123',remark2:'123',batch:'123',rate:'123',price1:'123',price2:'123',remark:'123',},
        {waybill:'BH2011541',type:'123',remark2:'123',batch:'123',rate:'123',price1:'123',price2:'123',remark:'123',},
      ],
      tableData3:[
        {waybill:'BH2011541',batch:'PC2011541',chassis:'DP2011541',brand:'品牌1',model:'型号',date1:'2021-10-30',date2:'2021-10-30',date3:'2021-10-30',start:'委托商1',end:'经销商1',type:'托运',rate:'1',price1:'60',price2:'70',remark:'相等'},
        {waybill:'BH2011541',batch:'PC2011541',chassis:'DP2011541',brand:'品牌1',model:'型号',date1:'2021-10-30',date2:'2021-10-30',date3:'2021-10-30',start:'委托商1',end:'经销商1',type:'托运',rate:'1',price1:'60',price2:'60',remark:'相等'},
      ],
      tableData4:[
        {waybill:'BH2011541',type:'123',remark2:'123',batch:'123',rate:'123',price1:'123',price2:'123',remark:'123',},
        {waybill:'BH2011541',type:'123',remark2:'123',batch:'123',rate:'123',price1:'123',price2:'133',remark:'123',},
      ],
      companyData:{},
      invoiceData:{
        img:[],
      },
      rules:{
        date:[
          { required: true, message: '请选择收取时间', trigger: 'change' },
        ],
      },
      carVisible:false,
      selectedCar:[],
      selectCar:[],
      brands:[],
      models:[],
      brands2:[],
      models2:[],
      selectBrand:[],
      selectModel:[],
      allCar:[],
      allModel:[],
      expands:[],
      addVisible:false,
      cost:{},
      costTable:[],
      selectCostTable:[],
      costTotal:0,
      costSize:0,
      costPage:0,
      invoiceVisible:false,
      auditVisible:false,
      auditData:{
        table2:[],
      },
      rules2:{
        deduction:[
          { required: true, message: '请选择是否抵扣超出合同价', trigger: 'change' },
        ],
        invoice:[
          { required: true, message: '请选择是否暂缓开票', trigger: 'change' },
        ],
        invoicePrice:[
          { required: true, message: '请输入暂缓开票金额', trigger: 'blur' },
        ],
        type:[
          { required: true, message: '请选择开票方式', trigger: 'change' },
        ],
        num:[
          { required: true, message: '请输入预计开票数量', trigger: 'blur' },
        ],
      },
      stepData:[
        {title:'张三发起',time:'2021-9-30 14:09:23',state:'',remark:''},
        {title:'财务部 张三通过',time:'2021-9-30 14:09:23',state:'success',remark:'原因xxxxxx'},
        {title:'技术部 李四拒绝',time:'2021-9-30 14:09:23',state:'failure',remark:'原因xxxxxx'},
        {title:'张三重新发起',time:'2021-9-30 14:09:23',state:'',remark:''},
      ],
      numOption:[
        {label:'D31835138135135',value:'1'},
        {label:'D31835138135135',value:'2'},
        {label:'D31835138135135',value:'3'},
        {label:'D31835138135135',value:'4'},
      ],
      uploadUrl:'',
      imgIsUpload:false,
    };
  },
  watch:{
    activeName(val){
      if(val==='first') this.detailDialogWidth='700px';
      if(val==='second') this.detailDialogWidth='1000px';
      if(val==='third') this.detailDialogWidth='1000px';
      if(val==='fourth') this.detailDialogWidth='800px';
    },
  },
  computed:{
    stepState(){
      return function(state){
        switch(state) {
          case '':
            return 'wait'
          case 'success':
            return 'success'
          case 'failure':
            return 'error'
        }
      };
    },
    getState(){
      return function(state){
        switch(state) {
          case 0:
            return '待生效'
          case 1:
            return '生效中'
          case 2:
            return '已失效'
        }
      };
    },
    getTime(){
      return function(time){
        return formatDateTime(time,'yyyy年mm月dd日 hh:ii:ss')
      };
    },
  },
  async mounted() {

  },
  methods: {
    compareDate(d1,d2) {
      return ((new Date(d1.replace(/-/g,"\/"))) > (new Date(d2.replace(/-/g,"\/"))));
    },
    // 结束时间
    dateChange(val) {
      if(this.timeIpt[1]&&this.timeIpt[0]&&this.compareDate(this.timeIpt[0],this.timeIpt[1])) {
        if(val == this.timeIpt[1]) this.timeIpt[1] = '';
        if(val == this.timeIpt[0]) this.timeIpt[0] = '';
        this.$forceUpdate();
        return this.$message.warning("结束日期必须大于开始日期！");
      }
    },
    contractSizeChange(sizes){
      this.size=sizes;
    },
    contractSizeChange1(sizes){
      this.costSize=sizes;
    },
    contractCurrentChange(page){
      this.page=page;
    },
    contractCurrentChange1(page){
      this.costPage=page;
    },
    detailClose(){
      this.detailDialogVisible=false;
      this.activeName='first'
    },
    dialogClose(){
      this.dialogVisible=false;
      this.activeName='first';
    },
    bjDate(date, date1) {
      var date = new Date(date);
      var date1 = new Date(date1);
      // 减小于0 date<date1
      return date.getTime() - date1.getTime() < 0;
    },
    addClick(){
      this.$refs.ruleForm.validate(async valid => {
        if (valid) {
          this.imgIsUpload = true;
          this.imgIsUpload = false;
          this.invoiceVisible=false;
        } else return false;
      });
    },
    nameChange(){},
    carClick(){
      this.carVisible=true;
      this.selectCar=[...this.selectedCar];
      this.brands=[...this.brands2];
      this.models=[...this.models2];
    },
    selectRemove(item){
      this.selectCar.splice(this.selectCar.indexOf(item),1)
      if(this.brands.indexOf(item)!==-1) this.brands.splice(this.brands.indexOf(item),1)
      else this.models.splice(this.models.indexOf(item),1)
    },
    brandAdd(item){
      if(this.selectCar.indexOf(item)!==-1) return this.$message.warning('已选择该品牌！');
      let arr = [];
      for(let i=0;i<this.allCar.length;i++){
        if(this.allCar[i].id===item.id){
          arr=this.allCar[i].carModel;
          break;
        }
      }
      for(let i=0;i<arr.length;i++){
        for(let j=0;j<this.selectCar.length;j++){
          if(arr[i].id===this.selectCar[j].id){
            this.selectCar.splice(j,1);
            j--;
          }
        }
      }
      this.selectCar.push(item)
      this.brands.push(item)
    },
    async addClose(){
      this.addVisible=false;
      this.cost={};
      this.selectCostTable.forEach(item=>{
        if(this.tableData2.indexOf(item) === -1) this.tableData2.push(item)
      })
      this.selectCostTable=[];
      this.costTable=[];
    },
    modelAdd(item){
      for(let i=0;i<this.selectCar.length;i++){
        if(this.selectCar[i].id===item.brandId) return this.$message.warning('上方已选择该品牌的全部车型！');
        else if(this.selectCar[i].id===item.id) return this.$message.warning('已选择该车型！');
      }
      this.selectCar.push(item)
      this.models.push(item)
    },
    carAddClick(){
      this.carVisible=false;
      this.selectedCar=[...this.selectCar];
      this.brands2=[...this.brands];
      this.models2=[...this.models];
    },
    tableRowClassName({row}) {
      if (row.price1!==row.price2) return 'ui-warning-row';
      else return '';
    },
    exportClick(){
      this.addVisible=true;
    },
    removeClick(index,val){
      if(val) this.tableData4.push(this.tableData2.splice(index, 1)[0])
      else this.tableData3.push(this.tableData1.splice(index, 1)[0])
    },
    addTableClick(index,val){
      if(val) {
        this.tableData2.push(this.tableData4[index])
        this.tableData4.splice(index,1)
      }
      else {
        this.tableData1.push(this.tableData3[index])
        this.tableData3.splice(index,1)
      }
    },
    resetBtn2(){
      this.cost={}
    },
    costSearch(){
      this.costTable=[
        {id:1,waybill:'BH2011541',type:'123',remark2:'123',batch:'123',rate:'123',price1:'123',price2:'222',remark:'123',},
        {id:2,waybill:'BH2011541',type:'123',remark2:'123',batch:'123',rate:'123',price1:'123',price2:'333',remark:'123',},
      ]
    },
    changePriceClick(val){},
    handleSelectionChange(val){
      this.selectCostTable=val;
    },
    selectAll(val){
      this.selectCostTable=val;
    },
    carClose(){
      this.carVisible=false;
    },
    brandClick(id){
      for(let i=0;i<this.allCar.length;i++){
        if(this.allCar[i].id===id){
          this.selectModel=this.allCar[i].carModel.map(item=>{
            return{
              id:item.id,
              name:item.brand_name,
              brandId:item.brand_id,
            }
          });
          break;
        }
      }
    },
    deleteClick(){
      this.$confirm('确认删除当前对账单吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
      }).catch(() => {});
    },
    collectionClick(){
      this.$confirm('确认要催收开票吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
      }).catch(() => {});
    },
    hiddenClick(index,row){
      this.TableDatas[index].tableShow=!this.TableDatas[index].tableShow;
      Array.prototype.remove = function (val) {
        let index = this.indexOf(val);
        if (index > -1) {
          this.splice(index, 1);
        }
      };
      if (this.expands.indexOf(row.id) < 0) {
        this.expands.push(row.id);
      } else {
        this.expands.remove(row.id);
      }
    },
    disableClick(){
      this.$confirm('确认要取消审核申请吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
      }).catch(() => {});
    },
    detailClick(){
      this.detailDialogVisible=true;
    },
    invoiceClose(){
      this.invoiceVisible=false;
      this.$refs.ruleForm.resetFields();
    },
    invoiceClick(){
      this.invoiceVisible=true;
      this.invoiceData={
        type:1,
        img:[],
      };
    },
    changeClick(){
      this.dialogVisible=true;
      this.dialogTitle='核对对账单'
    },
    searchBtn(){
      this.page = 1;
    },
    bindRowKeys(row){
      return row.id
    },
    resetBtn(){
      this.entrustIpt='';
      this.titleIpt='';
      this.numIpt='';
      this.typeIpt='';
      this.stateIpt='';
      this.timeIpt=['',''];
    },
    auditClick(id){
      this.auditVisible=true;
      this.auditData={
        deduction:1,
        invoice:1,
        type:1,
        total:500,
        maxPrice:100,
        num:2,
        invoicePrice:0,
        table:[
          {num:'1231231231',max:12,price:10}
        ],
        table2:[
          {price:100},
          {price:200},
        ],
      }
    },
    auditClose(){
      this.auditVisible=false;
      this.$refs.ruleForm2.resetFields();
    },
    auditConfirmClick(){
      this.$refs.ruleForm2.validate(async valid => {
        if (valid) {
          if(this.auditData.deduction===0){
            if(this.auditData.table.length===0) return this.$message.warning('抵扣费用表格不能为空！')
            for(let i=0;i<this.auditData.table.length;i++){
              if(!this.auditData.table[i].num || !this.auditData.table[i].price) return this.$message.warning('表格数据未填写完整！')
            }
          }
          if(this.auditData.type===0){
            if(this.auditData.table2.length===0) return this.$message.warning('开票表格不能为空！')
            for(let i=0;i<this.auditData.table2.length;i++){
              if(!this.auditData.table2[i].price) return this.$message.warning('开票表格未填写完整！')
            }
          }
          let totalNum=0;
          let num=0;
          this.auditData.table2.forEach(item=>{totalNum+=Number(item.price)})
          if(this.auditData.invoice===0){
            num=Number(this.auditData.total)-Number(this.auditData.invoicePrice)-totalNum;
          }else num=Number(this.auditData.total)-totalNum;
          if(num<0) return this.$message.warning(`开票金额与暂缓开票金额之和不能大于开票总金额！`)
          this.auditVisible=false;
        } else return false;
      });
    },
    numChange(index){
      this.auditData.table[index].max=123;
      this.auditData.table[index].price=456;
    },
    addCl(){
      this.auditData.table.push({num:''})
    },
    addCl2(){
      this.auditData.table2.push({price:''})
    },
    numRemoveClick(index){
      this.auditData.table.splice(index,1)
    },
    invoiceRemoveClick(index){
      this.auditData.table2.splice(index,1)
    },
    beforeAvatarUpload(file) {
      const TypeArr = ['image/jpeg', 'image/png', 'image/bmp', 'image/gif', 'image/jpg']
      const isJPG =TypeArr.includes(file.type)
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isJPG) this.$message.error('上传图片只能为jpg/png/jpeg/bmp/gif格式')
      if (!isLt10M) this.$message.error('上传图片大小不能超过 10MB')
      return isJPG && isLt10M
    },
    uploadChange(file, fileList){
      this.invoiceData.img=fileList;
      if (Object.keys(file).includes('response')){
        if (file.response.status !==0){
          this.invoiceData.img.splice(this.invoiceData.img.indexOf(file),1)
        }
      }
    },
    handleRemove(file,fileList) {
      this.invoiceData.img=fileList;
    },
    progress(){
      this.imgIsUpload=true;
    },
    success(res){
      if(res.status!==0) this.$message.error('该图片上传失败！')
      this.$message.success(res.message)
      this.imgIsUpload=false;
    },
  },
};
</script>



<style lang="scss" scoped>
.mainContainer{
  width:100%;
  padding:20px 15px 0 25px;
  .img-box{
    position: relative;
    width: 150px;
    height: 100px;
    img{
      width: 150px;
      height: 100px;
    }
    .tips{
      position: absolute;
      display:none;
    }
    &:hover .tips{
      display:block;
      position:absolute;
      //bottom:0;
      top:0;
      left:0;
      color:#FFF;
      width:146px;
      z-index:10;
      height:148px;
      background:#000;
      opacity: 0.6;
    }
  }
  .line{
    width: 12px;
    height: 32px;
    background-color: rgba(51, 84, 131, 100);
    margin-right: 10px;
  }
  .line +span{
    font-size: 16px;
    color: rgba(51, 84, 131, 100);
    font-weight: 600;
  }
  .nav{
    width:100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    &Container{
      width:200px;
      display: flex;
      align-items: center;
      margin-right: 5px;
      margin-bottom: 5px;
      p{
        font-size: 14px;
        color: rgba(16, 16, 16, 100);
      }
    }
    &Btn{
      display: flex;
      align-items: center;
      margin-bottom: 5px;
    }
    ::v-deep {
      label.el-form-item__label {
        font-weight: 500;
        color: #101010;
      }
    }
  }
  .content{
    display: flex;
    flex-direction: column;
    align-items: center;
    .tableContainer{
      margin-top: 30px;
      margin-bottom: 25px;
      width: 100%;
      ::v-deep{
        .el-table__expand-icon:after{
          content: '';
        }
        .el-table__expand-icon > i {
          display: none;
        }
        .el-table__expand-column {
          border-right: none;
        }
        body .el-table th.gutter {
          display: table-cell !important;
        }
        .el-badge__content{
          top: 4px !important;
          right: 1px !important;
        }
        .el-badge__content{
          background-color: #F56C6C !important;
        }
        .el-table .cell {
          padding: 0;
        }
        .el-table th{
          padding: 0;
        }
        .el-table td{
          padding: 0;
        }
      }
    }
    .paginationContainer{
      margin-right: auto;
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      span{
        font-size: 13px;
      }
    }
  }
  .carContainer{
    width:100%;
    padding: 15px 40px 10px 20px;
    max-height:75vh;
    overflow:auto;
    &Title{
      display: flex;
      flex-direction: column;
      span{
        color: #101010;
        font-weight: 700;
        margin-bottom: 5px;
      }
      &Content{
        width:100%;
        padding-left: 15px;
        display: flex;
        flex-wrap: wrap;
        align-items:center;
        margin-bottom: 10px;
        &Item{
          height:25px;
          padding:0 5px;
          background-color: #a4adb3;
          color:#fff;
          display: flex;
          align-items:center;
          justify-content:space-between;
          margin-right: 10px;
          margin-bottom: 5px;
          i{
            color:#000;
            font-size: 17px;
            cursor: pointer;
          }
          p{
            cursor: pointer;
          }
        }
      }
    }
    .btnContainer{
      width:100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 30px 0 10px 0;
      button{
        margin: 0 15px;
      }
    }
  }
  .detail{
    width: 100%;
    padding: 10px 0 20px 20px;
    max-height:80vh;
    overflow: auto;
    ::v-deep{
      .el-table td, .el-table th{
        padding:0;
      }
      .cell{
        font-size: 10px;
        padding:0;
      }
    }
    .baseInfo{
      display: flex;
      flex-direction: column;
      &Title{
        display:flex;
        align-items:flex-end;
        p{
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }
      &Content{
        display:flex;
        flex-direction: column;
        justify-content: space-between;
        padding:20px 23px 0 23px;
        &Item{
          margin-bottom: 20px;
          .imgContainer{
            display:flex;
            align-items: center;
          }
          .span1{
            font-weight: 700;
          }
          span{
            font-size: 14px;
          }
          .specialOne{
            width:50%;
          }
        }
        .specialItem{
          display:flex;
        }
      }
    }
    .operation{
      display: flex;
      flex-direction: column;
      ::v-deep{
        .el-table .ui-warning-row {
          background-color: #fef0f0!important;
        }
        .el-table--enable-row-hover .el-table__body tr.ui-warning-row:hover>td{
          background-color: #fef0f0!important;
        }
        .el-table .ui-warning-row .cell{
          color: red;
        }
      }
      &Title{
        display:flex;
        align-items:flex-end;
        p{
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }
      &Table{
        width:100%;
        margin-top: 10px;
        padding: 0 20px;
        &Nav{
          width:100%;
          display: flex;
          align-items: center;
          justify-content:flex-end;
          span{
            color: rgba(51, 136, 255, 1);
            text-decoration: underline;
            margin-right: 10px;
            &:hover{
              cursor: pointer;
            }
          }
        }
      }
    }
  }
  .reasonContainer{
    width:100%;
    padding: 20px 30px;
    ::v-deep{
      .el-textarea__inner{
        min-height: 100px!important;
      }
    }
    .reasonBtn{
      width: 100%;
      display: flex;
      align-items: center;
      justify-content:flex-end;
    }
  }
  .addCost{
    display: flex;
    flex-direction: column;
    padding: 10px 40px 10px 10px;
    max-height:75vh;
    overflow: auto;
    &Nav{
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }
    &Table{
      margin-top: 30px;
      margin-bottom: 25px;
      width: 100%;
      ::v-deep{
        .el-table__expand-icon:after{
          content: '';
        }
        .el-table__expand-icon > i {
          display: none;
        }
        .el-table__expand-column {
          border-right: none;
        }
        body .el-table th.gutter {
          display: table-cell !important;
        }
        .el-table__header .el-table-column--selection .cell .el-checkbox:after{
          color: rgb(127, 127, 127);
          content: "全选";
          font-size:12px;
          font-weight: 700;
          //margin-left: 2px;
        }
        .el-table__header .el-table-column--selection .cell .el-checkbox{
          margin-left: 8px;
        }
        .el-checkbox{
          margin-left: 16px;
        }
        .el-table .cell {
          padding: 0;
        }
        .el-table th{
          padding: 0;
        }
        .el-table td{
          padding: 0;
        }
      }
    }
    .paginationContainer{
      margin-right: auto;
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      span{
        font-size: 13px;
      }
    }
  }
  .depart{
    width:100%;
    padding: 10px 40px 10px 10px;
    max-height:75vh;
    overflow:auto;
    .imgUp{
      display: flex;
      flex-direction: column;
      .imgLength{
        display: flex;
        align-items: center;
        width:90%;
        span{
          margin-left:auto;
          color: rgb(183, 183, 183);
          font-size: 16px;
        }
      }
    }
    &Table{
      margin-bottom: 25px;
      width: 100%;
      .tableAddBtnContainer{
        border: 1px solid #EBEEF5;;
        border-top-style: none;
        width: 100%;
        height: 35px;
        display: flex;
        align-items: center;
        padding-left: 15px;
        .AddContainer{
          display: flex;
          align-items: center;
          &:hover{
            cursor: pointer;
          }
        }
        img{
          object-fit: cover;
          margin-right: 5px;
        }
        p{
          font-size: 13px;
          color: #F59A23;
          font-family: 'Arial Normal', 'Arial', sans-serif;
        }
      }
      ::v-deep{
        .el-table .cell {
          padding: 0;
        }
        .el-table th{
          padding: 0;
        }
        .el-table td{
          padding: 0;
        }
      }
    }
    .specialItem{
      ::v-deep {
        .el-form-item__content{
          margin-left: 0!important;
        }
      }
    }
    ::v-deep{
      .el-form-item__label{
        font-weight: 700;
      }
      .el-form-item{
        margin-bottom:13px;
      }
      .el-form-item__label{
        padding:0;
      }
      .el-form-item__content{
        position: relative;
      }
    }
    .btnContainer{
      width:100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 30px 0 10px 0;
      button{
        margin: 0 15px;
      }
    }
  }

  ::v-deep{
    .el-table th>.cell{
      font-weight: 700!important;
    }
  }
}
::v-deep{
  .el-dialog__header {
    padding: 9px 20px 9px;
    background: #335483;
  }
  .el-dialog__title {
    line-height: 24px;
    font-size: 14px;
    color: #FFFFFF;
  }
  .el-dialog__headerbtn{
    top:9px;
  }
  .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
    font-size: 25px;
  }
  .el-dialog__body {
    padding: 0;
  }
}
</style>
